import { Component, OnInit } from '@angular/core';
import { MasterService,ClassroomService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-hoddash',
  templateUrl: './hoddash.component.html',
  styleUrls: ['./hoddash.component.scss'],
  providers: [MasterService,ClassroomService]
})
export class HoddashComponent implements OnInit {
  objfilt: any={};
  classes: any=[];
  arrcourse: any=[];
  arrevpatern: any;
  selmember:any={};
  memberdetails:any[]=[];
  arrstuover: any;
  arrmen: any;

  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal,private cservice: ClassroomService) { }

  ngOnInit(): void {
    this.getcourses();
  }

  
    masclass() {
      this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.objfilt.clid=resultArray[0].clid;
             this.getobeoverview();
          },
          error => console.log("Error :: " + error)
          )
    }
  
    private getcourses() {
  
      this.mservice.getcourse()
    .subscribe((result:any) => {
    
    this.arrcourse=result;
    this.objfilt.crid=result[0].crid;
    
    this.masclass();
    
    }, error => {
    
    //alert('error in r');
    // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
    }
    );
      
      
    }


    private getobeoverview() {
  
      this.mservice.getobeoverview(this.objfilt)
    .subscribe((result:any) => {
    
    this.arrevpatern=result;
   
    
    }, error => {
    
    //alert('error in r');
    // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
    }
    );
      
      
    }


      onmemberselectEvent(item) {
//alert('hi');
    console.log('item',item);
    this.getdashstuoverview(this.selmember);
   
  }

  onmemberChangeSearch(sertxt) {
    debugger
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
    if(sertxt.query.length>=3) 
    {
    this.getmemberdetails(sertxt.query);
    }
  }

  getmemberdetails(sertxt) {
    debugger
    this.cservice.searchstudents(sertxt)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.memberdetails = resultArray;
        },
        error => console.log("Error :: " + error)
        )
  }

   private getdashstuoverview(obj) {
  
      this.mservice.getdashstuoverview(obj)
    .subscribe((result:any) => {
    
    this.arrstuover=result;
   this.getmenoverview(obj.stuid);
    
    }, error => {
    
    //alert('error in r');
    // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
    }
    );
      
      
    }

    private getmenoverview(stuid) {
  
      this.mservice.getmentschedules('selschmenbystuid', stuid)
    .subscribe((result:any) => {
    
    this.arrmen=result;
   
    
    }, error => {
    
    //alert('error in r');
    // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
    }
    );
      
      
    }
}
